<template>
    <div>
                <base-header style="background: rgba(79, 47, 129, 1);
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-5 pt-md-5">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
              
                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        </base-header>


        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <center><span style="font-size: 28px; color: black;">Ongoing Chats</span></center>
                        </div>
                        <div class="card-body">

<!--                           <h2>Timeline</h2>
                          <a-steps :current="current_date" size="small">
                            <a-step>
                              <template slot="title">
                                Schedule visit date
                              </template>
                              <span slot="description">{{date_1}}</span>
                            </a-step>
                            <a-step title="Actual visit date" :description="date_2" />
                            <a-step title="Schedule Audit Date" :description="date_3" />
                            <a-step title="Actual Audit Date" :description="date_4" />
                            
                          </a-steps>   -->
                          <!-- <br>
                          <h2>Findings Summary</h2>

                          <div class="col-xl-4">
                            
                          </div>


                          <div class="col-xl-12" v-if="loaded">


                              <card header-classes="bg-transparent">
                                  <div slot="header" class="row align-items-center">
                                      <div class="col">
                                          
                                          <base-progress type="default" :height="8" :value="60" label="Progress" style="margin-top: -20px;"></base-progress>
                                          
                          <center>
                            <h3>Findings</h3>
                          <div>
                            <span style="margin-left: 5px;margin-right: 0px;">V. High</span>
                            <span style="margin-left: 15px;margin-right: 2px;">High</span>
                            <span style="margin-left: 20px;margin-right: 12px;">Med</span>
                            <span style="margin-left: 14px;margin-right: 7px;">Low</span>
                            <span style="margin-left: 9px;margin-right: 7px;">V. Low</span>
                            <span style="margin-left: 30px;margin-right: 7px;">Total</span>
                          </div>
                          <div >
                              <span class="badge badge-pill badge-danger" style="margin-left : 10px;font-size: 20px;background-color: #bf2718; color: white;margin-right: 1px;">0</span>
                            <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 20px;background-color: #E74C3C; color: white;margin-right: 1px;">{{high_findings}}</span>
                            <span class="badge badge-pill badge-warning" style="margin-left : 5px;font-size: 20px; background-color: #F39C12;color: white;margin-right: 1px;">{{medium_findings}}</span>
                            <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 20px; background-color: #F4D03F; color: white;">{{low_findings}}</span>
                             
                             <span class="badge badge-pill badge-danger" style="margin-left : 5px;font-size: 20px;background-color: #ffeb14; color: white;margin-right: 1px;">0</span>
                             <span class="badge badge-pill badge-danger" style="margin-left : 10px;font-size: 20px; background-color: #dadada; color: black;">{{total_findings}}</span>
                          </div>
                          </center>

                                      </div>
                                  </div>

                                  <pie-chart
                                          :height="250"
                                          ref="pieChart"
                                          :chart-data="redBarChart.chartData"
                                  >
                                  </pie-chart>
                              </card>
                          </div> -->
                                    <!-- <br> -->
                                  <!-- <h3>Deliverables</h3> -->
                                    <card header-classes="bg-white" style="background-color: white;background: #fff;" >
                                      
                                      <!-- <div class="row">
                                        <div v-if="true" class="col-1">
                                        <badge type="danger" style="font-size: 14px;">1</badge>
                                      </div> -->
                                      <!-- </div> -->
                                      <div class="row">
                                        <div v-if="true" class="col-1">
                                        <badge type="danger" style="font-size: 14px;">1</badge>
                                      </div> 
                                        
                                        <h2 class="col-7">Inquiry </h2><div class="col-4"  style="width: 100%">

                                        <button type="button" style="float: right;margin-top: 10px;" class="btn btn-primary" v-on:click="onClick()"> View</button>

                                          </div>
                                        <!-- <br> -->
                                        <span class="col-8">Finance Committee report provided by Chair, Elizabeth Drucker:<br>
- Drucker explained that consultant, Susan Johns, reviewed the organization's bookkeeping procedures and found them to be satisfactory, in preparation for the upcoming yearly financial audit.<br><br></span>
                                        <br>
                                        <br>
                                        <br>
                                        <span class="col-8">Received : 2019-11-02</span> <span class="col-8">Participants : <badge type="primary" style="margin-left: 5px;">Nasser Barakat</badge><badge type="primary" style="margin-left: 5px;">Mohammad Montaser</badge><badge type="primary" style="margin-left: 5px;">Yousef Daoud</badge></span>
                                      </div>
                                    </card>
                                    <br>
                                  <card header-classes="bg-white" style="background-color: white;background: #fff;">
                                      
                                      <div class="row">

                                        <h2 class="col-8">Question from Nasser Barakat </h2><div class="col-4"  style="width: 100%">
                                        <button type="button" style="float: right;margin-top: 10px;" class="btn btn-primary" v-on:click="onClick()"> View</button>

                                          </div>
                                        <!-- <br> -->
                                        <span class="col-8">Finance Committee report provided by Chair, Elizabeth Drucker:<br>
- Drucker explained that consultant, Susan Johns, reviewed the organization's bookkeeping procedures and found them to be satisfactory, in preparation for the upcoming yearly financial audit.<br><br></span>
                                        <br>
                                        <br>
                                        <br>
                                        <span class="col-8">Uploaded : 2019-11-02</span>
                                      </div>
                                    </card>
                                    <br>
                                 

                          <!-- <div id="pdfdisplay" style="height: 1000px;"></div> -->

                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
<div>
          <beautiful-chat 
            :title="chatTitle"
            :participants="participants"
            :titleImageUrl="titleImageUrl"
            :onMessageWasSent="onMessageWasSent"
            :messageList="messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            :icons="icons"
            :open="openChat"
            :showEmoji="true"
            :showFile="true"
            :showTypingIndicator="showTypingIndicator"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            v-on:onType="handleOnType"
            v-on:edit="editMessage" />
        </div>

    </div>

</template>

<script>
    import { mapState } from "vuex";
  import { SEND_SMS } from "@/store/actions.type";
  import store from "@/store";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import PDFObject from 'pdfobject';
  import FullCalendar from '@fullcalendar/vue'
  import PieChart from '@/components/Charts/PieChart';
  import dayGridPlugin from '@fullcalendar/daygrid'
  import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
  import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
  import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
  import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'


  Vue.use(VueClipboard)
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker, FullCalendar,PieChart},
    data() {
      return {
        chatTitle : "Test123",

      calendarPlugins: [ dayGridPlugin ],
  
        loaded : true,
        title : 'Finance',
        high_findings : "3",
          medium_findings : "6",
          low_findings : "1",
          total_findings : String(10),
          current_date : 1,
           date_1 : "February 11, 2019",
          date_2 : "February 11, 2019",
          date_3 : "May 24, 2019",
          date_4 : "May 29, 2019",
          redBarChart: {
          chartData: {
            labels: ['High', 'Medium', "Low"],
            datasets: [{
                backgroundColor: ["#E74C3C", "#F39C12", "#F4D03F"],
              data: [30,60, 10],
            }]
          }
        },
              icons:{
        open:{
          img: OpenIcon,
          name: 'default',
        },
        close:{
          img: CloseIcon,
          name: 'default',
        },
        file:{
          img: FileIcon,
          name: 'default',
        },
        closeSvg:{
          img: CloseIconSvg,
          name: 'default',
        },
      },
      participants: [
        {
          id: 'user1',
          name: 'Othman Barakat',
          imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
        },
        {
          id: 'user2',
          name: 'Nasser Barakat',
          imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
        }
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
      messageList: [
          { type: 'text', author: `me`, data: { text: `Regarding the risk assessment report for phase 1, why is there a lack of documentation about the reported case on page 4 ?`,  meta: '06-16-2019 12:43' } },
          { type: 'text', author: `user1`, data: { text: `Dear Mr. Ahmad, we have looked into your enquiry and found that indeed there was a lack of documentation. We shall update the report.` } }
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      suggestions: ['some quick reply', 'another one'],
      newMessagesCount: 2,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4f2f81'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true
      
      }
    },
    methods: {
       sendMessage (text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
        this.onMessageWasSent({ author: 'support', type: 'text', data: { text } })
      }
    },
    onMessageWasSent (message) {
      // called when the user sends a message
      this.messageList = [ ...this.messageList, message ]
    },
    openChat () {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat () {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    handleScrollToTop () {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType () {
      console.log('Emit typing event')
    },
    editMessage(message){
      const m = this.messageList.find(m=>m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
      onSubmit() {
        // console.log("TITLE : " + this.title);
        // console.log("MESSAGE : " + this.message);
        // console.log("TIMESLOT : " + this.timeslot);
        // console.log("TIERS : ");
        // console.log(this.tiers);
        // console.log("DATE : " + this.dates.simple);
            if (this.phone_no !== '' && this.name !== '') {
                this.localerrors = null;
                

                let formData = {'name' : this.name, 'phone_no':this.phone_no};
                console.log(formData);
                Promise.all([
                  store.dispatch(SEND_SMS, formData),
                  
                ]).then(() => {
                    this.isLoading = false;
                    this.$router.push({ name: "overview" })
                });    
            }
            else {
                
              this.localerrors = "Name and Phone cannot be empty !"
                
            }
            
          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        },
      onChange(event) {
          this.timeslot = event.target.value;
          console.log(event);
      },
      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      },
       // onClick(token) {
       onClick() {
        this.openChat();
        // let token = "lol";
        //   this.$router.push({ name: 'deliverable', params: { token:  token} });
        }
    },
    mounted() {
      // PDFObject.embed("http://aicj.jo/wp-content/uploads/2019/07/F.S_AICJ_31-12-2018.pdf", "#pdfdisplay");
    }
    
  };
</script>
<style lang='scss'>

@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

</style>

